import React from 'react';
import PropTypes from 'prop-types';
import QuoteView from '../quoteView';

export default class QuoteExpeditedShippingComponent extends React.PureComponent {
  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
  };

  render() {
    return (
      <div className="card mb-3 box-shadow">
        <div className="alert alert-success">
          <h6 className="card-title text-center">
            Expedited Shipping Requested
          </h6>
          {this.props.quote.expeditedShipping.Notes && (
            <p style={{ whiteSpace: 'pre-line' }}>
              <strong>Details:</strong>
              <br />
              {this.props.quote.expeditedShippingNotes}
            </p>
          )}
        </div>
      </div>
    );
  }
}
